import React from 'react';

const SVG = ({ style = {}, color = 'rgb(255, 68, 68)', width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g stroke={color}>
      <circle cx="50" cy="50" r="46" fill="transparent" strokeWidth={8} />
      <line x1="28" y1="28" x2="72" y2="72" strokeWidth="10" />
      <line x1="28" y1="72" x2="72" y2="28" strokeWidth="10" />
    </g>
  </svg>
);

export default SVG;
